import { useState } from "react";
import { Alert } from "react-bootstrap";
import { PrimaryButton } from "components/Button/style";
import { DropdownSelect } from "components/DropdownSelect";
import { ZebraDevice } from "_services/zebraBrowserPrint/zebraBrowserPrint.service";
import { QzTraySetupModal } from "_services/zebraBrowserPrint/QzTraySetupModal";
import { DadosEtiquetaZpl } from "_services/zebraBrowserPrint/zplTemplate";
import { ILoteEstampagem } from "../../../interfaces/ILoteEstampagem";

interface ImpressoraBarProps {
  erroImpressora: string | null;
  impressora: ZebraDevice | null;
  impressoras: ZebraDevice[];
  lote: ILoteEstampagem;
  testeEtiqueta: DadosEtiquetaZpl;
  onVerificar: () => void;
  onCarregarImpressoras: () => void;
  onSelectImpressora: (device: ZebraDevice) => void;
  onImprimirPdf: (dados: DadosEtiquetaZpl) => void;
}

export function ImpressoraBar({
  erroImpressora,
  impressora,
  impressoras,
  lote,
  testeEtiqueta,
  onVerificar,
  onCarregarImpressoras,
  onSelectImpressora,
  onImprimirPdf,
}: ImpressoraBarProps) {
  const [showSetup, setShowSetup] = useState(false);
  const seletorImpressora = impressoras.length === 0 ? (
    <PrimaryButton outline variante="primary" buttonWidth="lg" buttonWidthTipo="px" onClick={onCarregarImpressoras}>
      Ver impressoras
    </PrimaryButton>
  ) : (
    <div style={{ minWidth: 220 }}>
      <DropdownSelect
        options={impressoras.map((imp) => ({ value: imp.uid, label: imp.name }))}
        title=""
        selectedValue={impressora?.uid ?? ""}
        onSelect={(uid) => {
          const selecionada = impressoras.find((imp) => imp.uid === uid);
          if (selecionada) { onSelectImpressora(selecionada); }
        }}
      />
    </div>
  );

  const acoesTeste = (
    <div className="d-flex align-items-center gap-2">
      <small className="text-muted">Teste:</small>
      {seletorImpressora}
      <PrimaryButton outline variante="primary" buttonWidth="md" buttonWidthTipo="px" onClick={() => onImprimirPdf(testeEtiqueta)}>
        PDF
      </PrimaryButton>
    </div>
  );

  if (erroImpressora) {
    return (
      <>
        <Alert variant="warning" className="mt-3 mx-3 py-2">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <span><strong>Impressora não conectada:</strong> {erroImpressora}</span>
            <div className="d-flex align-items-center gap-2">
              <PrimaryButton outline variante="primary" onClick={() => setShowSetup(true)}>
                Configurar
              </PrimaryButton>
              <PrimaryButton outline variante="primary" onClick={onVerificar}>
                Tentar novamente
              </PrimaryButton>
              {acoesTeste}
            </div>
          </div>
        </Alert>
        <QzTraySetupModal show={showSetup} onFechar={() => setShowSetup(false)} />
      </>
    );
  }

  return (
    <Alert variant="success" className="mt-3 mx-3 py-2">
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <span>
          <strong>Impressora:</strong> {impressora?.name ?? "—"}
          <span className={`badge ms-3 ${lote.status === "ABERTO" ? "bg-success" : "bg-secondary"}`}>
            {lote.status}
          </span>
          {lote.comTag && <span className="badge bg-info ms-2">Com Tag</span>}
          {lote.tagJaRegistrada && <span className="badge bg-warning text-dark ms-2">Tag Registrada</span>}
          {lote.localEntrega && (
            <span className="ms-3 text-muted" style={{ fontSize: "0.85rem" }}>📍 {lote.localEntrega}</span>
          )}
        </span>
        {acoesTeste}
      </div>
    </Alert>
  );
}
